import { Component, OnInit } from '@angular/core';
import { isBuffer } from 'lodash';
import { ApplicationContextService, AuthenService, ComCtxConstants, ComponentContextService, EntityMetadataService, StorageUpdatedService, TnUser } from 'tnx-shared';
import { ActivatedRoute, NavigationStart, Route, Router } from '@angular/router';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector: 'authen-app',
    templateUrl: './authen-app.component.html',
    styleUrls: ['./authen-app.component.scss'],
    providers: [ComponentContextService, EntityMetadataService]
})
export class AuthenAppComponent implements OnInit {

    waiting = false;

    constructor(
        private _applicationContext: ApplicationContextService,
        public _componentContextService: ComponentContextService,
        private _activatedRoute: ActivatedRoute,
        private _oauthService: OAuthService,
        private _storageUpdatedService: StorageUpdatedService,
        private _authenService: AuthenService,
        private _router: Router,
    ) {
        this._applicationContext.addRootContext(
            this._componentContextService,
            _activatedRoute,

        );

        this._oauthService.events.subscribe(evt => {
            if (evt.type == 'token_received') {
                // đọc lại từ localstorage ra redirect ở đây
                this._applicationContext.getRootContext().fireReplayEvent(ComCtxConstants.ROOT.USER_READY, true);
                // this.completeAuthentication();
            }
            // else if (evt.type === 'logout') {
            //     // cleanup storage
            //     localStorage.removeItem('user_info');
            //     this._authenService.cleanupLocalStorage();
            //     this._storageUpdatedService.cleanupStorageService();
            //     this._oauthService.revokeTokenAndLogout(null, true);
            // }
            // else if (evt.type == 'token_expires') {
            //     this._authenService.logout();
            // }
        });
    }

    ngOnInit() {
        if (!this._oauthService.hasValidAccessToken()) {
            // if (!localStorage.getItem('currentUrl')) {
            //     localStorage.setItem('currentUrl', top.location.href);
            // }
            // this._oauthService.loadDiscoveryDocumentAndTryLogin().then(rs => {
            //     if (!this._oauthService.hasValidAccessToken()) {
            //         this._oauthService.initLoginFlow();
            //     }
            // }).catch(err => {
            //     this._oauthService.initLoginFlow();
            // });
            window.location.href = '/';
        } else {
            // this._componentContextService.fireReplayEvent(
            //     ComCtxConstants.ROOT.USER_READY,
            //     true
            // );

            // this._oauthService.setupAutomaticSilentRefresh();
        }

        this._componentContextService.subscribe(ComCtxConstants.ROOT.SHOW_WAIT_BOX, data => {
            this.waiting = data;
        });
    }

    focusTrap(evt, st) {

    }
}
